// 数据列表 post
export const monitorDataList =
  "/api/oauth/device/monitorData/selectDeviceMonitorDataList";

//设备列表 get
export const deviceMonitorData =
  "/api/oauth/device/monitorData/selectDeviceMonitorDataNew";

//  平均值 post
export const deviceMonitorDataAvg =
  "/api/oauth/device/monitorData/selectDeviceMonitorDataAvg";

//  合计值 post
export const deviceMonitorDataTotal =
  "/api/oauth/device/monitorData/selectDeviceMonitorDataTotal";

// 数据列表1 post
export const monitorDataList1 =
  "/api/oauth/device/monitorDataMeteorology/selectDeviceMonitorDataMeteorologyList";

//设备列表1 get
export const deviceMonitorData1 =
  "/api/oauth/device/monitorDataMeteorology/selectDeviceMonitorDataMeteorologyNew";

//  平均值1 post
export const deviceMonitorDataAvg1 =
  "/api/oauth/device/monitorDataMeteorology/selectDeviceMonitorDataMeteorologyAvg";

//  合计值1 post
export const deviceMonitorDataTotal1 =
  "/api/oauth/device/monitorDataMeteorology/selectDeviceMonitorDataMeteorologyTotal";
